module.exports = __webpack_public_path__ + "img/background-organization.77d5bd0f.jpg";